

































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import * as service from '@/services/parameters';
import BaseComponent from '@/components/base-component.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import { cloneDeep } from 'lodash';
import ParameterModel from '@/models/parameter-model';
@Component({
  components: { PermissionAuth },
})
export default class InfusionTimeForm extends BaseComponent {
  @Prop()
  public isEdit: boolean = false;
  @Prop()
  public editItem: any;

  public form: any = {
    valid: false,
    rules: {
      description: [(v) => (!!v && Number(v) > 0) || 'Digite um tempo válido'],
    },
  };

  public $refs!: {
    form: HTMLFormElement;
  };

  public item: any = {};

  @Watch('editItem')
  public onEditItemChanges(val: any) {
    this.item = val;
  }

  public saveItem(): void {
    this.$refs.form.validate();
    if (!this.form.valid) {
      return;
    }

    this.loader.stop();
    this.$emit('save', this.item);
    this.$refs.form.resetValidation();
  }

  public closeForm(): void {
    const closeAction = () => {
      setTimeout(() => {
        this.$refs.form.resetValidation();
      }, 100);
      this.$emit('close');
    };

    this.dialog.show(
      'error',
      'Sair sem salvar',
      'Deseja sair sem salvar as alterações?',
      'Cancelar',
      '',
      'Sair',
      closeAction,
    );
  }
}
